// オフスクリーン操作
class OffScreen {
    constructor(width, height) {
        this.canvas = document.createElement("canvas");
        this.context = this.canvas.getContext("2d");
        this.canvas.width = width;
        this.canvas.height = height;
    }
    clear(){
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    drawWhite(){
        this.context.save()
        this.context.fillStyle = "rgb(255,255,255)"
        this.context.fillRect(0,0,this.canvas.width,this.canvas.height)
        this.context.restore()
    }
    drawImage(image, x, y, width, height) {
        this.context.drawImage(image, Math.floor(x), Math.floor(y), width, height);
    }
    drawImageRotate(image, x, y, width, height, rotate) {
        // コンテキストを保存する
        this.context.save();
        // 回転の中心に原点を移動する
        this.context.translate(this.canvas.width / 2, this.canvas.height / 2);
        // canvasを回転する
        this.context.rotate((rotate * Math.PI) / 180);
        this.context.translate(-this.canvas.width / 2, -this.canvas.height / 2);
        this.context.drawImage(image, Math.floor(x), Math.floor(y), width, height);
        this.context.restore();
    }
    drawTrimmingImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
        this.context.drawImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight);
    }
    drawUpDownTrimmingImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
        // コンテキストを保存する
        this.context.save();
        // 回転の中心に原点を移動する
        this.context.translate(this.canvas.width / 2, this.canvas.height / 2);
        // canvasを回転する
        this.context.rotate(Math.PI);
        // 画像サイズの半分だけずらして画像を描画する
        this.context.drawImage(image, -(image.width / 2), -(image.height / 2));
        // コンテキストを元に戻す
        this.context.drawImage(image, sx, sy, swidth, sheight, dx - this.canvas.width / 2, dy - this.canvas.height / 2, dwidth, dheight);

        this.context.restore();
    }
    downloadImage() {
        let link = document.createElement("a");
        link.href = this.canvas.toDataURL("image/png");
        link.download = "test.png";
        link.click();
    }
    canvasImage() {
        return this.canvas.toDataURL("image/png")
    }
    toBlob(callback) {
        return this.canvas.toBlob(callback)
    }
    makeBlob(image, callback) {
        this.context.drawImage(image, 0, 0, image.width, image.height);
        this.toBlob(callback)
    }
    // アルファ値の計算(0~100)
    // 左上から右下までの面積が塗り潰し面積
    // 
    getAlphaValue() {

        let mg = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        if(!this.imageData) this.imageData = mg
        let firstPosX = 0
        let firstPosY = 0
        let endPosX = 0
        let endPosY = 0
        let breakflag = false
        // 最初の左
        for (let x = 0; x < this.canvas.width; x++) {
            for (let y = 0; y < this.canvas.height; y++) {

                let index = ((this.canvas.width * y) + x) * 4
                let myAlpha = mg.data[index + 3]

                if (myAlpha > 0) {
                    firstPosX = x
                    breakflag = true
                    break
                }
            }
            if (breakflag) {
                break
            }
        }
        breakflag = false

        // 最初の右
        for (let x = this.canvas.width - 1; x >= 0; x--) {
            for (let y = 0; y < this.canvas.height; y++) {

                let index = ((this.canvas.width * y) + x) * 4
                let myAlpha = mg.data[index + 3]

                if (myAlpha > 0) {
                    endPosX = x
                    breakflag = true
                    break
                }
            }
            if (breakflag) {
                break
            }
        }
        breakflag = false

        // 最初の上
        for (let y = 0; y < this.canvas.height; y++) {
            for (let x = 0; x < this.canvas.width; x++) {
                let index = ((this.canvas.width * y) + x) * 4
                let myAlpha = mg.data[index + 3]

                if (myAlpha > 0) {
                    firstPosY = y
                    breakflag = true
                    break
                }
            }
            if (breakflag) {
                break
            }
        }
        breakflag = false
        // 最初の下
        for (let y = this.canvas.height - 1; y >= 0; y--) {
            for (let x = this.canvas.width - 1; x >= 0; x--) {
                let index = ((this.canvas.width * y) + x) * 4
                let myAlpha = mg.data[index + 3];
                if (myAlpha > 0) {
                    endPosY = y
                    breakflag = true
                    break
                }
            }
            if (breakflag) {
                break
            }
        }
        let allArea = this.canvas.width * this.canvas.height
        let fillArea = ((endPosX + 1) - firstPosX) * ((endPosY + 1) - firstPosY)
        // this.context.fillStyle = "#c003";
        // this.context.fillRect(firstPosX, firstPosY, endPosX - firstPosX, endPosY - firstPosY)
        return {
            alphaValue: fillArea / allArea,
            paintedRect: {
                x: firstPosX,
                y: firstPosY,
                width: endPosX - firstPosX,
                height: endPosY - firstPosY
            }
        }
    }

    drawSrcImage(image, x, y, width, height) {
        this.context.save()

        this.context.globalCompositeOperation = 'source-over';
        this.context.drawImage(image, x, y, width, height);
        this.context.restore()

    }
    drawDstImage(image, x, y, width, height) {
        this.context.save()
        this.context.globalCompositeOperation = 'destination-in';
        this.context.drawImage(image, x, y, width, height);
        this.context.restore()

    }
    drawSrcInImage(image, x, y, width, height) {
        this.context.save()
        this.context.globalCompositeOperation = 'source-in';
        this.context.drawImage(image, x, y, width, height);
        this.context.restore()

    }
    fillColor(r, g, b) {
        this.context.save()
        this.context.globalCompositeOperation = 'source-over';
        this.context.fillStyle = `rgb(${r},${g},${b})`
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.context.restore()
    }
    saturation(val) {
        this.context.save()
        this.context.globalCompositeOperation = 'saturation';
        this.context.globalAlpha = Math.abs(val)
        if (val < 0) {
            this.context.fillStyle = ``
        } else {
            this.context.fillStyle = `red`
        }

        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.context.restore()
    }

    luminosity(val) {
        this.context.save()
        this.context.globalCompositeOperation = 'luminosity';
        this.context.globalAlpha = Math.abs(val)
        if (val < 0) {
            this.context.fillStyle = ``
        } else {
            this.context.fillStyle = `red`
        }

        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.context.restore()
    }
    /**
     * ガンマ補正
     * @param {補正値 0-10} val 
     */
    ganmma(val) {
        var gamma = val;

        var src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        var dst = this.context.createImageData(this.canvas.width, this.canvas.height);

        for (var i = 0; i < src.data.length; i = i + 4) {
            dst.data[i] = ~~(255 * Math.pow((src.data[i] / 255), 1 / gamma));    //R
            dst.data[i + 1] = ~~(255 * Math.pow((src.data[i + 1] / 255), 1 / gamma));  //G
            dst.data[i + 2] = ~~(255 * Math.pow((src.data[i + 2] / 255), 1 / gamma));  //B
            dst.data[i + 3] = src.data[i + 3];    //A
        }

        this.context.putImageData(dst, 0, 0);
    }
    /**
     * 乗算
     * @param {}} image 
     * @param {*} x 
     * @param {*} y 
     * @param {*} width 
     * @param {*} height 
     */
    drawMultiply(image, x, y, width, height) {
        this.context.save()
        this.context.globalCompositeOperation = 'multiply';
        this.context.drawImage(image, x, y, width, height);
        this.context.restore()

    }
    // 白引き回数を指定
    brightnessAlpha(){
        let src = null
        if(this.imageData){
            src = this.imageData
        } else {
            src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        }
        
        var dst = this.context.createImageData(this.canvas.width, this.canvas.height);

        for (var i = 0; i < src.data.length; i = i + 4) {
            let r = src.data[i]
            let g = src.data[i + 1]
            let b = src.data[i + 2]
            let a = src.data[i + 3]
            let hsv = this.rgb2hsv([r,g,b])

            // let newa = a * ((255.0 - hsv[2] * Math.pow(hsv[2] / 255.0,3.0)) / 255.0)  
            let newa =  (255.0 - hsv[2]) + 30
            if(newa > 255) newa = 255
            if(newa < 0) newa = 0

            if(a == 0 || newa == 0){
                dst.data[i] = src.data[i]
                dst.data[i + 1] = src.data[i + 1] 
                dst.data[i + 2] = src.data[i + 2]
                dst.data[i + 3] = src.data[i + 3]
            } else {
                dst.data[i] = this.normalize(r / (a / 255.0) * (newa / 255.0) )
                dst.data[i + 1] = this.normalize(g / (a / 255.0) * (newa / 255.0))
                dst.data[i + 2] = this.normalize(b / (a / 255.0) * (newa / 255.0))
                dst.data[i + 3] = newa.toFixed()
            }
        }

        this.context.putImageData(dst, 0, 0);
    }
    // 白引き回数を指定
    trim(){
        return new Promise((resolve)=>{
            let mg = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
            if(!this.imageData) this.imageData = mg
            let firstPosX = 0
            let firstPosY = 0
            let endPosX = 0
            let endPosY = 0
            let breakflag = false
    
            // 最初の左
            for (let x = 0; x < this.canvas.width; x++) {
                for (let y = 0; y < this.canvas.height; y++) {
    
                    let index = ((this.canvas.width * y) + x) * 4
    
                    if (!(mg.data[index] == 255 && mg.data[index + 1] == 255 && mg.data[index + 2] == 255)) {
                        firstPosX = x
                        breakflag = true
                        break
                    }
                }
                if (breakflag) {
                    break
                }
            }
            breakflag = false
    
            // 最初の右
            for (let x = this.canvas.width - 1; x >= 0; x--) {
                for (let y = 0; y < this.canvas.height; y++) {
    
                    let index = ((this.canvas.width * y) + x) * 4
    
                    if (!(mg.data[index] == 255 && mg.data[index + 1] == 255 && mg.data[index + 2] == 255)) {
                        endPosX = x
                        breakflag = true
                        break
                    }
                }
                if (breakflag) {
                    break
                }
            }
            breakflag = false
    
            // 最初の上
            for (let y = 0; y < this.canvas.height; y++) {
                for (let x = 0; x < this.canvas.width; x++) {
                    let index = ((this.canvas.width * y) + x) * 4
    
                    if (!(mg.data[index] == 255 && mg.data[index + 1] == 255 && mg.data[index + 2] == 255)) {
                        firstPosY = y
                        breakflag = true
                        break
                    }
                }
                if (breakflag) {
                    break
                }
            }
            breakflag = false
            // 最初の下
            for (let y = this.canvas.height - 1; y >= 0; y--) {
                for (let x = this.canvas.width - 1; x >= 0; x--) {
                    let index = ((this.canvas.width * y) + x) * 4
                    if (!(mg.data[index] == 255 && mg.data[index + 1] == 255 && mg.data[index + 2] == 255)) {
                        endPosY = y
                        breakflag = true
                        break
                    }
                }
                if (breakflag) {
                    break
                }
            }
            firstPosX -= 10
            if(firstPosX < 0) firstPosX = 0
            firstPosY -= 10
            if(firstPosY < 0) firstPosY = 0
            endPosX += 10
            if(endPosX > this.canvas.width) endPosX = this.canvas.width 
            endPosY += 10
            if(endPosY > this.canvas.height) endPosY = this.canvas.height
            let sc = new OffScreen(endPosX-firstPosX,endPosY-firstPosY)
            let img = new Image()
            img.src = this.canvasImage()
            img.onload = ()=>{
                sc.drawTrimmingImage(img,firstPosX,firstPosY,endPosX-firstPosX,endPosY-firstPosY,0,0,endPosX-firstPosX,endPosY-firstPosY)
                resolve(sc)
            }
        })
    }
    normalize(val){
        return val > 255 ? 255 : val < 0 ? 0 : val;
    }
    rgb2hsv ( rgb ) {
        var r = rgb[0] / 255 ;
        var g = rgb[1] / 255 ;
        var b = rgb[2] / 255 ;
    
        var max = Math.max( r, g, b ) ;
        var min = Math.min( r, g, b ) ;
        var diff = max - min ;
    
        var h = 0 ;
    
        switch( min ) {
            case max :
                h = 0 ;
            break ;
    
            case r :
                h = (60 * ((b - g) / diff)) + 180 ;
            break ;
    
            case g :
                h = (60 * ((r - b) / diff)) + 300 ;
            break ;
    
            case b :
                h = (60 * ((g - r) / diff)) + 60 ;
            break ;
        }
    
        var s = max == 0 ? 0 : diff / max ;
        var v = max ;
    
        return [ h, s*256, v*256 ] ;
    }
    hsv2rgb(h, s, v) {
        // 引数処理
        s /= 256
        v /= 256
        h = (h < 0 ? 360 + h % 360 : h % 360) / 60;
        s = s < 0 ? 0 : s > 1 ? 1 : s;
        v = v < 0 ? 0 : v > 1 ? 1 : v;
    
        // HSV to RGB 変換
        const c = [v, v, v]
          , a = Math.floor(h)
          , f = h - a;
        c[Math.floor(a / 2 + 2) % 3] *= (1 - s);
        c[(7 - a) % 3] *= (1 - s * (a % 2 ? f : 1 - f));
        for (let i in c)
            c[i] = Math.round(c[i] * 255);
    
        // 戻り値
        return {
            hex: '#' + (('00000' + (c[0] << 16 | c[1] << 8 | c[2]).toString(16)).slice(-6)),
            rgb: c,
            r: c[0],
            g: c[1],
            b: c[2],
        };
    }
    // mono画像用に変換
    // アルファの値を元にモノクロ画像に変換
    monochrome(){
        let src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        let dst = this.context.createImageData(this.canvas.width, this.canvas.height);
        for ( let i= 0; i < src.data.length; i += 4 ){
            dst.data[i] = 255 - src.data[i + 3];
            dst.data[i + 1] = 255 - src.data[i + 3];
            dst.data[i + 2] = 255 - src.data[i + 3];
            dst.data[i + 3] = 255;
        }
        this.context.putImageData(dst, 0, 0);
    }
    // 指定の色を透過色に変換
    transparent(r, g, b){
        let src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        let dst = this.context.createImageData(this.canvas.width, this.canvas.height);
        for ( let i= 0; i < src.data.length; i += 4 ){
            if( src.data[i] == r && src.data[i + 1] == g && src.data[i + 2] == b ){
                dst.data[i] = src.data[i];
                dst.data[i + 1] = src.data[i + 1];
                dst.data[i + 2] = src.data[i + 2];
                dst.data[i + 3] = 0;
            }else{
                dst.data[i] = src.data[i];
                dst.data[i + 1] = src.data[i + 1];
                dst.data[i + 2] = src.data[i + 2];
                dst.data[i + 3] = src.data[i + 3];
            }
        }
        this.context.putImageData(dst, 0, 0);
    }
    // 透過色以外を指定の色に置換する
    replacement(colorCode){
        var r = parseInt(colorCode.substring(1,3), 16);
        var g = parseInt(colorCode.substring(3,5), 16);
        var b = parseInt(colorCode.substring(5,7), 16);

        let src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        let dst = this.context.createImageData(this.canvas.width, this.canvas.height);
        for ( let i= 0; i < src.data.length; i += 4 ){
            if( src.data[i + 3] != 0 ){
                dst.data[i] = r;
                dst.data[i + 1] = g;
                dst.data[i + 2] = b;
                dst.data[i + 3] = src.data[i + 3];
            }
        }
        this.context.putImageData(dst, 0, 0);
    }
    /**
     * 画像全体の透明度を変更する
     * @param {number} opacity 透明度 (0.0〜1.0)
     */
    setOpacity(opacity = 1.0) {
    const src = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    const dst = this.context.createImageData(this.canvas.width, this.canvas.height);

    for (let i = 0; i < src.data.length; i += 4) {
        dst.data[i]     = src.data[i];     // R
        dst.data[i + 1] = src.data[i + 1]; // G
        dst.data[i + 2] = src.data[i + 2]; // B
        dst.data[i + 3] = Math.round(src.data[i + 3] * opacity); // A × 透明度
    }

    this.context.putImageData(dst, 0, 0);
    }
}
export { OffScreen }
